export default __webpack_public_path__ + "static/media/dgk_Logo.dff4a250.svg";